import React from 'react';
import Tooltip, {TooltipProps, tooltipClasses} from '@mui/material/Tooltip';
import {styled} from '@mui/material/styles';

const LightTooltip = styled(({className, ...props}: TooltipProps) => (
   <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
   [`& .${tooltipClasses.tooltip}`]: {
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      maxWidth: 250,
      fontSize: 11
   }
}));
export default LightTooltip;
